import axios from 'axios'
var baseUri = "WebApi.asmx/api/menuService";
const store = {};
const mutations = {
    SET_SITEMAP_LIST(state, posts) { 
        if (posts.data.length > 0) {

            posts.data.forEach(m => {

                if (m.Icon) {
                    m.IconClass = 'mnTileIcon ' + m.Icon;
                }
                else {
                    m.IconClass = m.HasChildren ? 'mnTileIcon fal fa-long-arrow-right' : 'mnTileIcon fal fa-sign-in';
                }
                if (m.ParentKey > "") {
                    m.Parent = posts.data.find(p => {
                        return m.ParentKey == p.Key;
                    }
                    );
                }
            });

            var root = posts.data[0];
            posts.data.filter(m => m.ParentKey == root.Key).forEach(m => m.ParentKey = "");
            posts.data.shift();
            posts.data = posts.data.filter(m => m.HideInIndex == false);
            state.siteMapRoot = root;
            var node = posts.data.find(m => m.Id == state.rootMenuId);

            if (state.rootMenuId > "" && node != null) {
                state.currentKey = node.Key;
            }
            else {
                state.currentKey = "";
            }
        }
        state.siteMap = posts.data;
        state.siteMapIsLoading = false;
    }
};
const state = {
    siteMapIsLoading: false,
    siteMap: [],
    currentKey: "",
    rootMenuId: ""
};
const getters = {};
const actions = {
    getSiteMap({ commit }, menuId) {
        state.siteMapIsLoading = true;
        state.rootMenuId = menuId;
        axios
            .post(baseUri + '/GetMenu')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_SITEMAP_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}